import { useRef, useState } from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import "../../custom-css/scan.css";
import authService from "../../Auth/AuthService";
// import thannk from '../assets/thank-you-alot.mp3'
import dayjs from "dayjs";

const getShift = (time) => {
    const hour = time.hour();
    if (hour >= 6 && hour < 14) return "MORNING";
    if (hour >= 14 && hour < 22) return "EVENING";
    return "NIGHT";
};

export default function ScannerPage() {

    const [status, setStatus] = useState("Starting camera...");
    const [stop, setStop] = useState(true);
    const audioRef = useRef(new Audio("../assets/thank-you-alot.mp3"));
    const scannedRef = useRef(false);

    const handleUpdate = (err, result) => {
        if (result && !scannedRef.current) {
            scannedRef.current = true;

            // 🔊 play beep
            audioRef.current.currentTime = 0;
            audioRef.current.play().catch(()=>{});

            console.log("SCANNED:", result.text);
            setStatus("DETECTED ✔");
            punchIn(result.text);
            setStop(false);
            setTimeout(() => {
                scannedRef.current = false;
                setStop(true);
                setStatus(null);
            }, 3000);
        }
    };

    const punchIn = async (code) => {

        const now = dayjs();
        const autoShift = getShift(now);

        const data = {
            distance: code,
            attendDate: now,
            inTime: now.format("HH:mm"),
            shift: autoShift,
            month: now.month(),
        };

        console.log("Punch In:", data);

        const url = authService.pathUrl("POST", "/attendance/punch/qrcode");
        await authService.postAuth(url, data);
    };

    return (

        <div style={{
            padding: 30,
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'column',
            alignContent: 'center',
            alignItems: 'center',
        }}>
            <h2>Scanner</h2>
            {stop && (
                <div className="scanner-wrapper">

                    <BarcodeScannerComponent
                        width={500}
                        height={400}
                        onUpdate={handleUpdate}
                    />

                    {/* GREEN scanning overlay */}
                    <div className="scan-box">
                        <div className="scan-line"></div>
                    </div>

                </div>
            )}

            <h3>{status}</h3>

        </div>

    );

}